export function summarizeCandidate(candidate?: string | null) {
  if (!candidate) {
    return { type: 'missing' };
  }
  const tokens = candidate.trim().split(/\s+/);
  const typIndex = tokens.indexOf('typ');
  return {
    foundation: tokens[0]?.replace(/^candidate:/, ''),
    protocol: tokens[2],
    address: tokens[4],
    port: tokens[5],
    type: typIndex >= 0 ? tokens[typIndex + 1] : 'unknown',
  };
}

export function normalizeCandidate(candidate: RTCIceCandidateInit) {
  if (candidate.usernameFragment || !candidate.candidate) {
    return candidate;
  }
  const usernameFragment = candidate.candidate.match(/\bufrag\s+([^\s]+)/)?.[1];
  return usernameFragment ? { ...candidate, usernameFragment } : candidate;
}

export function createIceCandidate(candidate: RTCIceCandidateInit) {
  return new RTCIceCandidate(normalizeCandidate(candidate));
}
